import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import DepollutionTable from "../../components/depollution/DepollutionTable";
import { usePageNameContext } from "../../contexts/PageTitleContext";

export default function DepollutionList() {
  const { t } = useTranslation("vehicles");
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: t("Depollution"),
      desc: t("Vehicles with Depollution still in progress"),
    });
  }, [t]);

  return <DepollutionTable />;
}
